import Marquee from "react-fast-marquee";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Phone, MessageCircle, Sparkles, CheckCircle2, Zap, ShieldCheck, CreditCard, Globe2, Coins } from "lucide-react";
import { bookCtaClick } from "@/lib/bookCta";
import { PHONE_HREF, trackPhoneCall } from "@/lib/contact";

export default function MarqueeStrip() {
  const navigate = useNavigate();
  const handleBook = (e) => bookCtaClick(e, navigate);

  const items = [
    { type: "tag", icon: Sparkles, text: "FREE VENDING MACHINES" },
    { type: "tag", icon: Globe2, text: "COUNTRY-WIDE" },
    {
      type: "btn",
      kind: "call",
    },
    { type: "tag", icon: CheckCircle2, text: "30+ STAFF / FOOT TRAFFIC" },
    { type: "tag", icon: ShieldCheck, text: "FULLY STOCKED" },
    {
      type: "btn",
      kind: "contact",
    },
    { type: "tag", icon: Zap, text: "FULLY SERVICED" },
    { type: "tag", icon: CreditCard, text: "TAP & GO PAYMENTS" },
    {
      type: "btn",
      kind: "book",
    },
    { type: "tag", icon: Coins, text: "ZERO UPFRONT" },
  ];

  const pillBase =
    "group relative inline-flex items-center gap-2 rounded-full px-5 py-2 font-display font-black text-[11px] sm:text-xs tracking-[0.16em] uppercase bg-[#FE7200] text-black hover:bg-[#FF8C2E] transition-colors duration-300 shadow-[0_0_18px_rgba(254,114,0,0.45)]";

  const renderItem = (it, i) => {
    if (it.type === "btn") {
      if (it.kind === "call") {
        return (
          <a
            key={`call-${i}`}
            href={PHONE_HREF}
            onClick={trackPhoneCall}
            data-testid="marquee-call-button"
            className={pillBase}
          >
            <Phone className="h-3.5 w-3.5" />
            <span>Call Now</span>
          </a>
        );
      }
      if (it.kind === "contact") {
        return (
          <a
            key={`contact-${i}`}
            href="/contact"
            data-testid="marquee-contact-link"
            className={pillBase}
          >
            <MessageCircle className="h-3.5 w-3.5" />
            <span>Contact Us</span>
          </a>
        );
      }
      if (it.kind === "book") {
        return (
          <a
            key={`book-${i}`}
            href="#book-form"
            onClick={handleBook}
            data-testid="marquee-cta-button"
            className={pillBase}
          >
            <span>Book Site Visit</span>
            <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        );
      }
    }
    const Icon = it.icon;
    return (
      <span key={`tag-${i}`} className="flex items-center gap-2.5">
        <Icon className="h-4 w-4 text-[#FE7200]" />
        <span>{it.text}</span>
      </span>
    );
  };

  return (
    <div
      data-testid="marquee-strip"
      className="relative w-full overflow-hidden bg-black border-y border-white/10 text-white"
    >
      {/* subtle orange glow line */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(254,114,0,0.18),transparent_60%)]" />

      <div className="relative">
        <Marquee speed={48} gradient={false} pauseOnHover>
          <div className="flex items-center gap-8 py-3 pl-10 pr-2 font-display font-black tracking-[0.22em] text-xs sm:text-sm uppercase text-white">
            {items.concat(items).map((it, i) => (
              <span key={i} className="flex items-center gap-8">
                {renderItem(it, i)}
                <span className="relative inline-flex h-2 w-2" aria-hidden>
                  <span className="absolute inset-0 rounded-full bg-[#FE7200]" />
                  <span className="absolute inset-0 rounded-full animate-ping bg-[#FE7200]/50" />
                </span>
              </span>
            ))}
          </div>
        </Marquee>
      </div>
    </div>
  );
}
